import { render, staticRenderFns } from "./GanttView.vue?vue&type=template&id=542a9dcc&"
import script from "./GanttView.vue?vue&type=script&lang=js&"
export * from "./GanttView.vue?vue&type=script&lang=js&"
import style0 from "./GanttView.vue?vue&type=style&index=0&id=542a9dcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports